import {createSelector} from 'reselect';
import {getPages} from '~/stores/player/selectors/course.selectors';
import {PAGE_ID_SPEED_COURSE} from '~/utils/constants';

export const getCourse = ({course}) => course;

export const getUserData = state => state.course?.userData?.pages;
export const getUserResult = state => state.course?.data?.result;
export const getSaveTime = state => state.course?.data?.saveTime;

export const getShowPage = state => state.course?.showPage;

// export const isSpeedCoursePage = (pageId, {pages}) => {
//   if (!pageId && pageId !== 0 || !Array.isArray(pages)) {
//     throw new Error('invalid arguments');
//   }
//   const pageIndex = pages?.findIndex(page => page.id === pageId);

//   if (pageIndex === -1) {
//     return false;
//   }
//   const speedCourseIntroPageIndex = pages?.findIndex(page => page.id === PAGE_ID_SPEED_COURSE);

//   if (speedCourseIntroPageIndex === -1) {
//     return false;
//   }

//   return speedCourseIntroPageIndex <= pageIndex;
// };

export const getSpeedCourseEnabled = createSelector(
  getPages,
  pages => !!pages?.some?.(page => page.id === PAGE_ID_SPEED_COURSE),
);

export const getPreviewMode = ({course: {previewMode}}) => previewMode;

export const getPageSize = ({course: {pageSize}}) => pageSize;

export const getPageSizing = state => state.course?.data?.settings?.pageSizing;

export const getCourseSettings = state => state.course?.data?.settings;
export const getMeetingType = state => state.course?.isMeeting;
export const getCourseType = state => state.course?.courseType;

export const getPageType = ({course}) => course.data?.settings?.pageType || '1';

export const getShouldUseDynamicSize = () => false;

export const getAssets = ({course: {assets}}) => assets;

export const getShowSettings = ({course: {showSettings}}) => showSettings;
